module.exports = __webpack_public_path__ + "site/img/54.65ad8e41.jpg";